import React from 'react'

const Footer = () => {
  return (
    <div className=' fixed 
    inset-x-0 
    bottom-0 
    p-4  text-center text-gray-200 bg-gray-900'>
        Developed by: MADHUR VILAS KANNAMWAR (2451-21-733-110), Guided by: T.Sujanavan, Assistant Professor, Dept. of CSE, MVSREC
    </div>
    
  )
}

export default Footer